import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'
import ListCountries from './ListCountries'
import EditCountries from './EditCountries'
import NewCountries from './NewCountries'

const AdminCountriesRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListCountries /></PrivateRoute7>} />
        <Route path="edit-country" element={<PrivateRoute7><EditCountries /></PrivateRoute7>} />
        <Route path="new-country" element={<PrivateRoute7><NewCountries /></PrivateRoute7>} />
    </Routes>
  )
}

export default AdminCountriesRoutes